module.exports = __webpack_public_path__ + "img/service2.3606bb71.png";